export type { ErrorSubdomainKey, ErrorSubdomainValue } from './domain';
export {
  ErrorSubdomain,
  ReservedSubDomain,
  isErrorSubdomain,
  REDIRECT_PATH_QUERY_KEY,
  VIEWER_HOST_HEADER_KEY,
  ABNORMAL_LEGACY_SUBDOMAINS,
} from './domain';
